export default __webpack_public_path__ + "static/media/C4.155e402a.jpg";